import { Collapse } from 'bootstrap';

document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash;

  if (hash) {
    const target = document.querySelector(hash);

    if (target && target.classList.contains('collapse')) {
      const collapseInstance = Collapse.getInstance(target);

      if (collapseInstance) {
        collapseInstance.show();
      } else {
        new Collapse(target, {
          toggle: true
        });
      }

      document.addEventListener('shown.bs.collapse', function (event) {
        if (event.target === target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }
});
